module.exports = __webpack_public_path__ + "78529e001ba211541966ffbffc21af44.jpg";